import { render, staticRenderFns } from "./AbsentLetterDetail.vue?vue&type=template&id=7b2faef4&scoped=true"
import script from "./AbsentLetterDetail.vue?vue&type=script&lang=js"
export * from "./AbsentLetterDetail.vue?vue&type=script&lang=js"
import style0 from "./AbsentLetterDetail.vue?vue&type=style&index=0&id=7b2faef4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2faef4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b2faef4')) {
      api.createRecord('7b2faef4', component.options)
    } else {
      api.reload('7b2faef4', component.options)
    }
    module.hot.accept("./AbsentLetterDetail.vue?vue&type=template&id=7b2faef4&scoped=true", function () {
      api.rerender('7b2faef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/absent_letter_v3/components/dialog/AbsentLetterDetail.vue"
export default component.exports